module.exports = __webpack_public_path__ + "static/img/fusion_icon.a865c7ea.png";